import { Component, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from "@/theme/ThemeComponent";
import { EastSlider } from '../EastSlider/EastSlider';

@Component
export class FeaturedContent extends ThemeComponent {
    @Ref({ required: false }) buttonPrevious!: HTMLButtonElement;
    @Ref({ required: false }) buttonNext!: HTMLButtonElement;
    @Ref({ required: false }) featuredSlide!: EastSlider;

    init() {
        if (this.buttonPrevious) {
            this.$listen(this.buttonPrevious, 'click', () => this.scrollContainer('left'));
        }

        if (this.buttonNext) {
            this.$listen(this.buttonNext, 'click', () => this.scrollContainer('right'));
        }

        if (this.featuredSlide) {
            this.updateButtonState();
        }
    }

    scrollContainer(direction: string) {
        const swiper = this.featuredSlide.swiper;

        if (!swiper) { return; }

        if (direction == 'right') {
            swiper.slideNext();
        } else {
            swiper.slidePrev();
        }

        this.updateButtonState();
    }

    updateButtonState() {
        const swiper = this.featuredSlide.swiper;

        if (!swiper) {
            return;
        }

        // Check if we're at the beginning or the end of the slides
        const isAtBeginning = swiper.isBeginning;
        const isAtEnd = swiper.isEnd;

        if (this.buttonPrevious) {
            if (isAtBeginning) {
                this.buttonPrevious.setAttribute('disabled', 'true');
            } else {
                this.buttonPrevious.removeAttribute('disabled');
            }
        }

        if (this.buttonNext) {
            if (isAtEnd) {
                this.buttonNext.setAttribute('disabled', 'true');
            } else {
                this.buttonNext.removeAttribute('disabled');
            }
        }
    }
}
